(function () {

    angular
    .module('meanApp')
    .directive('tagDescription', tagDescription);
  
        tagDescription.$inject = ['$compile'];
        function tagDescription ($compile) {
            return {
                restrict: 'AE',
                templateUrl: 'common/directives/tag/modal.tag.template.html',
                controller: 'tagCtrl',
                replace: true,
                scope: {
                    tag : '@tagdesc',
                    searchbutton: '@'
                },
                link : function(scope, element, attrs) {
                    element[0].className='tag-description-modal category ';
                    //element[0].setAttribute('hm-press', 'that.onTagPressed('+attrs.tag+')');
                    //$compile(element)(scope);
                }
            };
        }
  
  })();